import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {LocalStorage} from "../../utils/LocalStorage";
import {LoginWithGoogle} from "./LoginWithGoogle";
import {Navigate} from "react-router-dom";
import { withTranslation } from "react-i18next";
import {FaIcon} from "../FaIcon";
import {isNetworkError, isOk} from "../../utils/apiResponse";

// El ancho del botón de Google es un número en píxeles (Google no acepta porcentajes): el de la
// columna del login, o lo que entre en un celular con 16px de margen a cada lado.
const GOOGLE_BUTTON_MAX_WIDTH = 380;

function googleButtonWidth() {
    return Math.min(GOOGLE_BUTTON_MAX_WIDTH, window.innerWidth - 32);
}

class LoginButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoggedIn: false,
            firstTime: null,
            invitationPendingHash: null,
            // `null` = sin error. Hasta el 15/10 un error salía en un `alert()` con el texto crudo, y
            // uno de red (`NETWORK_ERROR`) no entraba en ninguna rama: el botón no hacía nada.
            error: null
        };

        this.handleGoogleLoginSuccessful = this.handleGoogleLoginSuccessful.bind(this);
        this.handleGoogleLoginFailed = this.handleGoogleLoginFailed.bind(this);
    }

    /**
     * El backend del login no tiene errores con motivo: todo lo que no es OK es una caída (un 500 si
     * Google no valida el token) o la red. Por eso se elige el copy por `isNetworkError` y nunca se
     * muestra el `error_message`, que puede ser el genérico del `APIClient` o un `detail` en inglés.
     */
    handleGoogleLoginSuccessful(accountData) {
        this.setState({error: null});
        new APIClient(API_URL + 'login/').call('POST', accountData)
            .then((responseData) => {
                if (isOk(responseData)) {
                    this.handleLoginSuccessful(responseData);
                } else {
                    const {t} = this.props;
                    this.setState({error: isNetworkError(responseData) ? t('login.error_network') : t('login.error_generic')});
                }
            });
    }

    handleGoogleLoginFailed() {
        this.setState({error: this.props.t('login.error_google')});
    }

    handleLoginSuccessful(responseData) {
        const userData = responseData.logged_user_data;

        if (userData) {
            LocalStorage.saveUserData(userData.user_id, userData.token, userData.user_type, userData.agency_status, userData.language, userData.client_id || null, userData.is_dashbo_mcp, userData.free_trial_days_remaining, userData.agency_logo_url, userData.agency_display_name, userData.brand_primary_color, userData.brand_secondary_color, userData.portal_theme);
            LocalStorage.updateTrialNextStep(userData.trial_next_step);
            // Portal multi-cliente: snapshot de clients[] (branding + features + modules por
            // cliente). Con backend viejo la key no viene y el portal cae al fallback legacy.
            LocalStorage.saveUserClients(userData.clients || null);
        }

        if (responseData.first_time_logged) {
            this.setState({firstTime: true, isLoggedIn: true, invitationPendingHash: responseData.invitation_pending_hash});
        } else {
            this.setState({firstTime: false, isLoggedIn: true, invitation_pending_hash: null});
        }
    }

    _homePath() {
        return {pathname: "/"};
    }

    _getRedirectPath() {
        // Verificar si hay una URL guardada para redirigir después del login
        const redirectUrl = LocalStorage.getRedirectUrl();
        if (redirectUrl) {
            LocalStorage.clearRedirectUrl();
            // Usar la URL completa directamente (incluye pathname + query params)
            return redirectUrl;
        }
        return this._homePath();
    }

    _registrationPath() {
        return {pathname: "/agency-register"};
    }

    _acceptInvitationPath(hash) {
        return {pathname: "/accept-invitation/"+hash};
    }

    render() {
        const { t } = this.props;
        if (this.state.isLoggedIn) {
            if (this.state.firstTime) {
                if(this.state.invitationPendingHash)
                    return <Navigate to={this._acceptInvitationPath(this.state.invitationPendingHash)}/>
                return <Navigate to={this._registrationPath()}/>;
            } else {
                return <Navigate to={this._getRedirectPath()}/>;
            }
        } else {
            return (
                <>
                    {this.state.error && (
                        <div className="login-error" role="alert">
                            <FaIcon iconName="circle-exclamation" className="login-error-icon"/>
                            <p className="login-error-text">{this.state.error}</p>
                        </div>
                    )}
                    <LoginWithGoogle
                        onGoogleLoginSucessful={this.handleGoogleLoginSuccessful}
                        onFailure={this.handleGoogleLoginFailed}
                        buttonText={t('login.with_google')}
                        width={googleButtonWidth()}
                        text={this.props.googleText}
                    />
                </>
            );
        }
    }
}

export default withTranslation()(LoginButton);
